import { CloseRounded } from "@mui/icons-material";
import { Divider, IconButton } from "@mui/material";
import { Tabs } from "layout";
import React, { useEffect, useState } from "react";
import SpecifyPeriod from "./SpecifyPeriod";
import SpecifyDate from "./SpecifyDate";
import { Button } from "controls";
import { formatDate } from "hooks";
import dayjs from "dayjs";

const DateRangeForm = ({
  setShowForm,
  setFilterVal,
  filterVal,
  allowAll = true,
}) => {
  const [values, setValues] = useState({});

  useEffect(() => {
    setValues((prev) => ({ ...prev, ...filterVal }));
  }, [filterVal]);

  const [errors, setErrors] = useState({
    numberOfPeriod: "",
  });

  const format = `DD MMM, YYYY ${values?.timePeriod === 6 ? ", hh:mm A" : ""}`;

  const handleClose = () => {
    setShowForm(false);
  };

  const handleSubmit = () => {
    setFilterVal((prev) => ({ ...prev, ...values }));
    handleClose();
  };

  const handleChgType = (val) => {
    setValues((prev) => ({ ...prev, type: val }));
  };

  useEffect(() => {
    setErrors((prev) => ({
      ...prev,
      numberOfPeriod:
        dayjs(values.toDate).diff(values.fromDate, "month") > 50
          ? "Choose a date range that isn’t wider than 50 months"
          : "",
    }));
    return () => {};
  }, [values?.fromDate, values?.toDate]);

  const renderBody = () => {
    switch (allowAll) {
      case true:
        return (
          <Tabs
            onChange={handleChgType}
            className="mt-[5px]"
            active={filterVal.type - 1 || null}
            header={[
              { id: 1, label: "All" },
              { id: 2, label: "Specify Period" },
              { id: 3, label: "Specify Date" },
            ]}
          >
            <div></div>
            <SpecifyPeriod {...{ values, setValues, setErrors, errors }} />
            <SpecifyDate {...{ values, setValues, errors }} />
          </Tabs>
        );
      case false:
        return (
          <Tabs
            onChange={handleChgType}
            className="mt-[5px]"
            active={filterVal.type - 1 || null}
            header={[
              { id: 2, label: "Specify Period" },
              { id: 3, label: "Specify Date" },
            ]}
          >
            <SpecifyPeriod {...{ values, setValues, setErrors, errors }} />
            <SpecifyDate {...{ values, setValues, errors }} />
          </Tabs>
        );
      default:
        break;
    }
  };

  return (
    <div className="bg-slate-50">
      <div className="flex justify-between items-center p-[7px] pb-[4px]">
        <span className="text-[18px] uppercase font-medium text-gray-500 pl-[7px] tracking-wider">
          Select Date Range
        </span>
        <IconButton size="small" onClick={handleClose}>
          <CloseRounded />
        </IconButton>
      </div>
      <Divider />
      <div className="p-[12px]">{renderBody()}</div>

      {/* ----------- Footer ----------- */}
      <div className="bg-primary-100 mt-[5px] p-[7px] flex justify-between items-center">
        {values.type === 1 ? (
          <span className="text-[16px] pl-[10px] font-medium text-gray-500">
            All time
          </span>
        ) : (
          <div className="flex gap-2 text-[14px] text-primary-600 pl-[5px]">
            <div className="flex flex-col">
              <span>From </span>
              <span>To </span>
            </div>
            <div className="flex flex-col">
              <span>
                :&nbsp;
                {formatDate(values.fromDate, format)}
              </span>
              <span>
                :&nbsp;
                {formatDate(values.toDate, format)}
              </span>
            </div>
          </div>
        )}

        <Button onClick={handleSubmit} disabled={!!errors?.numberOfPeriod}>
          Apply
        </Button>
      </div>
    </div>
  );
};

export default DateRangeForm;
